// extracted by mini-css-extract-plugin
module.exports = {"news":"news_news__1MbHJ","infoblock":"news_infoblock__37FA2"};